import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { ReactComponent as WriteIcon } from 'svg/fi_write.svg'
import {
  Control,
  FieldArrayWithId,
  FieldErrors,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FormValues } from 'utils/type'
import { Me, Usage } from 'service/user'

import { LinkDetailType } from 'service/list'
import classNames from 'classnames'
import { isMobile } from 'react-device-detect'

import { ReactComponent as ImageIcon } from 'svg/fi_image.svg'

import { ReactComponent as YoutubeIcon } from 'svg/fi_youtube.svg'
import { ReactComponent as EditIcon } from 'svg/fi_edit.svg'
import { ReactComponent as StarIcon } from 'svg/star_white.svg'
import { ProductScript } from './ProductScript'
import { ReactComponent as UlClipBoardIcon } from 'svg/u_clipboard.svg'
import { ScriptTooltip } from '../tooltip/ScriptTooltip'
import { UpdateTag } from 'components/tag/UpdateTag'
interface ProductItemEmptyProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  fields: FieldArrayWithId<FormValues, 'products', 'id'>[]
  errors: FieldErrors<FormValues>
  setErrorText: Dispatch<React.SetStateAction<React.ReactNode>>
  userInfo: Me
  usage: Usage | undefined
  error: {
    products: {
      link: boolean
      product: boolean
    }[]
    mainTitle: boolean
    thumbnail: boolean
  }
  selectedLinks: LinkDetailType[]
  setError: any
  isAiName: boolean

  isOpenLinkMethod: boolean
  isOpenExtensionMethod: boolean
  setOpenLinkMethod: Dispatch<SetStateAction<boolean>>
  setOpenExtensionMethod: Dispatch<SetStateAction<boolean>>
}

const ProductItemEmpty = ({
  watch,
  setValue,
  control,
  fields,
  errors,
  error,
  setErrorText,
  userInfo,
  usage,
  selectedLinks,
  setError,
  isAiName,
  isOpenLinkMethod,
  isOpenExtensionMethod,
  setOpenLinkMethod,
  setOpenExtensionMethod,
}: PropsWithChildren<ProductItemEmptyProps>) => {
  const [isOpenTooltip, setOpenTooltip] = useState<boolean>(false)
  return (
    <div
      className={classNames(
        'flex flex-col items-center w-[375px] md:w-full gap-1',
        { 'px-4': isMobile }
      )}
    >
      <p className="text-[18px] font-bold bg-[#2E343D] text-white w-full rounded-[6px] px-2">
        상품 1
      </p>
      {/* 상품명 입력 */}
      <div className="flex flex-col w-full mt-6 gap-2">
        <p className="w-full font-bold flex gap-2 items-center">
          <EditIcon />
          상품명 편집
        </p>
        <div className="product_name cursor-pointer">
          <p
            className={classNames(
              'px-2 py-1 rounded-[4px] inline-flex gap-2 items-center',
              {
                'bg-[#BBEBEC]': true,
              }
            )}
          >
            {' '}
            <span className="font-bold text-white bg-[#2E343D] flex  items-center w-[65px] h-[22px] rounded-[4px] text-[12px] justify-center ">
              <StarIcon className="text-white" /> AI 추천
            </span>
            {'--'}
          </p>
        </div>
        <div className=" cursor-pointer">
          <p
            className={classNames(
              'px-2 py-1 rounded-[4px] inline-flex gap-2 items-center',
              {
                'bg-[#EEF1F7] ': true,
              }
            )}
          >
            <span className="text-[12px] bg-[#8F929B] px-1 py-[2px] text-white shrink-0 rounded-[4px] font-bold">
              원본
            </span>
            {'--'}
          </p>
        </div>
      </div>
      <div className=" relative w-full">
        <textarea
          value={`패스트컷 확장프로그램에서 수집한 쿠팡이나 알리익스프레스 상품을 먼저 선택해${
            isMobile ? '' : '\n'
          }주셔야 영상으로 만들 상품명을 불러올 수 있어요!`}
          className="text-error w-full border-[1px] border-[#D9DEE8] rounded-[10px] md:h-[80px] h-[100px] px-4 py-4  mt-2 bg-white"
          disabled
        />
        {/* <button
          className={classNames(
            'text-[14px] font-bold text-white bg-main rounded-full h-[48px]  flex items-center justify-center gap-2 w-[156px] absolute md:top-[28%] -top-14 right-3',
            {}
          )}
          type="button"
          onClick={() => {
            if (isOpenLinkMethod && !isOpenExtensionMethod) {
              setOpenLinkMethod(false)
            }
            setOpenExtensionMethod((prev) => !prev)
          }}
        >
          <UlClipBoardIcon />
          상품 선택하기
        </button> */}
      </div>
      {/* 스크립트 생성 */}
      <div className="flex flex-col w-full  mt-6">
        <div className="w-full flex justify-between relative">
          <p className="flex gap-2 items-center">
            <WriteIcon />
            <span className="font-bold">대본 생성 & 편집</span>
            <UpdateTag />
          </p>
        </div>

        <div className="flex flex-col border-[1px] rounded-[10px] mt-2 ">
          <div className="w-full  px-3 py-2  rounded-t-[10px] bg-[#F6F8FB]">
            <div className="flex  md:flex-row flex-col md:items-center justify-between gap-2">
              <div className="w-full  md:h-[61px] rounded-[10px] bg-white px-4 py-5 flex items-center justify-between font-bold ">
                <div className="w-full flex md:flex-row flex-col md:items-center md:gap-5 gap-4">
                  <p className="flex items-center text-[14px] gap-2 flex-shrink-0 ">
                    <span className="bg-[#D9DEE8] px-1 py-[2px] text-[#8F929B] rounded-[4px] flex-shrink-0">
                      컨셉
                    </span>
                    <span className=" text-[#8F929B]">{'바이럴형'}</span>
                  </p>
                  <p className="flex items-center text-[14px] gap-2">
                    <span className="bg-[#D9DEE8] px-1 py-[2px] text-[#8F929B] rounded-[4px] flex-shrink-0">
                      말투
                    </span>
                    <span className="text-[#8F929B]">
                      {'와 이런게 있다고?'}
                    </span>
                  </p>{' '}
                </div>
                <button
                  className="px-2 py-[6px] bg-[#2E343D] text-[white] rounded-[4px] text-[14px] shrink-0 disabled:bg-[#D9DEE8]"
                  type="button"
                  disabled
                >
                  선택 {'>'}
                </button>
              </div>
              <div className=" shrink-0 flex justify-center">
                <button
                  type="button"
                  className="flex gap-2 items-center shrink-1 bg-[#2E343D] rounded-full px-6 py-3 disabled:bg-[#D9DEE8]"
                  disabled
                >
                  <StarIcon />
                  <span className="font-bold text-white">대본 생성하기</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 상품 영상 선택 */}
      <div className="flex flex-col w-full mt-6">
        <p className="w-full font-bold flex gap-2 items-center">
          <YoutubeIcon />
          상품 영상 선택 0/0
        </p>
        <p className="w-full text-[14px] text-[#8F929B]">
          사용하고 싶은 영상을 선택해주세요. (최우선으로 사용되며, 영상 길이가
          충분할 경우 이미지는 사용되지 않습니다.)
        </p>
      </div>
      <div className={classNames('flex flex-col w-full mt-6', {})}>
        <p className="w-full font-bold flex gap-2 items-center">
          <ImageIcon />
          상품 대표 이미지 선택 0/0
        </p>
        <p className="w-full text-[14px] text-[#8F929B]">
          사용하고 싶은 이미지를 선택해주세요. (영상 길이에 따라 선택한 이미지가
          모두 사용되지 않을 수 있습니다)
        </p>
      </div>
      <div className={classNames('flex flex-col w-full mt-6 relative', {})}>
        <p className="w-full font-bold flex gap-2 items-center">
          <ImageIcon />
          상품 상세페이지 이미지 선택 0 /0
        </p>
        <p className="w-full text-[14px] text-[#8F929B]">
          사용하고 싶은 이미지를 선택해주세요. (영상 길이에 따라 선택한 이미지가
          모두 사용되지 않을 수 있습니다)
        </p>
      </div>

      {/* 상품 이미지 선택 */}
      {/* <ProductImageSelector
        selectedLink={selectedLink}
        index={index}
        setValue={setValue}
        watch={watch}
      /> */}

      {/* 상품 상세 이미지 */}
      {/* <ProductDetailImageSelector
        selectedLink={selectedLink}
        index={index}
        setValue={setValue}
        watch={watch}
      /> */}

      {/* 이미지 업로드 */}
      {/* <FileUploader watch={watch} i={index} setValue={setValue} /> */}
    </div>
  )
}

export default ProductItemEmpty
